import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import { take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as i1 from '@ft-alts/ui-components/src/lib/shared-lib';
import { SwitchModule } from '@ft-alts/ui-components/src/lib/shared-lib';
import * as i2 from '@bloomreach/ng-sdk';
import { BrSdkModule } from '@bloomreach/ng-sdk';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2$1 from '@ft-alts/ui-components/src/lib/performance-lib';
import { PERF_CONFIG, PerfTabsService } from '@ft-alts/ui-components/src/lib/performance-lib';
import * as i3 from '@ft-alts/ui-components/src/lib/common-lib';
import { HttpClientModule } from '@angular/common/http';
import { ProductHeroModule } from '@ft-alts/ui-components/src/lib/products-lib';

function HomepageComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementContainer(1, 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    i0.ɵɵclassMapInterpolate1("grid-container ", row_r1.cssClass, "");
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("brComponent", "grid-content-", i_r2, "");
} }
class HomepageComponent {
    constructor(animationService, viewModeService) {
        this.animationService = animationService;
        this.viewModeService = viewModeService;
        this.isEditMode = false;
        this.unsubscribe$ = new Subject();
        this.animationService.showAnimation$.pipe(take(1), takeUntil(this.unsubscribe$)).subscribe((status) => {
            this.animationService.setShowAnimation(status);
        });
        this.isEditMode = this.viewModeService.isEditMode();
    }
    /**
     * On Init
     */
    ngOnInit() {
        var _a, _b, _c, _d;
        this.pageDocument = (_a = this.page) === null || _a === void 0 ? void 0 : _a.getDocument();
        this.gridRows = (_d = (_c = (_b = this.pageDocument) === null || _b === void 0 ? void 0 : _b.model) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.gridRow;
        if (this.gridRows) {
            // Set CSS Classes
            for (const row of this.gridRows) {
                if (row.layout) {
                    row.cssClass = this.getCSSClass(row.layout);
                }
            }
        }
    }
    getCSSClass(layout) {
        switch (layout.trim()) {
            case '1 | 1':
                return 'one-one';
            case '1 | 1 | 1':
                return 'one-one-one';
            case '1 | 2':
                return 'one-two';
            case '2 | 1':
                return 'two-one';
            default:
                return 'default-layout';
        }
    }
    /**
     * unsubscribes from pageScroll, animation service when service is destroyed
     */
    ngOnDestroy() {
        this.unsubscribe$.complete();
    }
}
HomepageComponent.ɵfac = function HomepageComponent_Factory(t) { return new (t || HomepageComponent)(i0.ɵɵdirectiveInject(i1.AnimationService), i0.ɵɵdirectiveInject(i1.ViewModeService)); };
HomepageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HomepageComponent, selectors: [["ft-alts-homepage"]], inputs: { page: "page" }, decls: 18, vars: 1, consts: [["id", "skip-link-target", 1, "main-content"], [1, "homepage"], [1, "grid", "alts-scroll-line"], [1, "grid", "alts-homepage-hero"], [1, "alts-homepage-hero__background"], ["xmlns", "http://www.w3.org/2000/svg", "width", "1536", "height", "531", "viewBox", "0 0 1536 531", "fill", "none"], ["d", "M409 244.815C148.5 497.315 0 531 0 531H1536C1359.5 347.5 1196.9 146.477 1052.5 68C776.5 -81.9998 625.246 35.2099 409 244.815Z", "fill", "url(#paint0_linear_2407_74571)"], ["id", "paint0_linear_2407_74571", "x1", "534.5", "y1", "121.5", "x2", "907.5", "y2", "449", "gradientUnits", "userSpaceOnUse"], ["stop-color", "#A124CC", "stop-opacity", "0.5"], ["offset", "0.6", "stop-color", "#A124CC", "stop-opacity", "0.1"], ["offset", "1", "stop-color", "#A124CC", "stop-opacity", "0"], ["brComponent", "lead-content"], ["id", "broad-capabilities"], ["brComponent", "title-content"], ["brComponent", "main-content"], [1, "grid"], [3, "class", 4, "ngFor", "ngForOf"], [3, "brComponent"]], template: function HomepageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "main", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "aside", 2);
        i0.ɵɵelementStart(3, "section", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(5, "svg", 5);
        i0.ɵɵelement(6, "path", 6);
        i0.ɵɵelementStart(7, "defs");
        i0.ɵɵelementStart(8, "linearGradient", 7);
        i0.ɵɵelement(9, "stop", 8);
        i0.ɵɵelement(10, "stop", 9);
        i0.ɵɵelement(11, "stop", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementContainer(12, 11);
        i0.ɵɵelement(13, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainer(14, 13);
        i0.ɵɵelementContainer(15, 14);
        i0.ɵɵelementStart(16, "div", 15);
        i0.ɵɵtemplate(17, HomepageComponent_div_17_Template, 2, 4, "div", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(17);
        i0.ɵɵproperty("ngForOf", ctx.gridRows);
    } }, directives: [i2.BrComponentDirective, i5.NgForOf], styles: [".alts-homepage-hero[_ngcontent-%COMP%]{position:relative}.alts-homepage-hero__background[_ngcontent-%COMP%]{z-index:-10;overflow:hidden;width:100%;height:47%;position:absolute;top:0;left:0;background:var(--ft-gradient-blue-to-teal-4)}@media (min-width: 768px){.alts-homepage-hero__background[_ngcontent-%COMP%]{height:60%}}@media (min-width: 1024px){.alts-homepage-hero__background[_ngcontent-%COMP%]{height:73%}}.alts-homepage-hero__background[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{position:absolute;left:50%;bottom:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HomepageComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-homepage',
                templateUrl: './homepage.component.html',
                styleUrls: ['./homepage.component.scss'],
            }]
    }], function () { return [{ type: i1.AnimationService }, { type: i1.ViewModeService }]; }, { page: [{
            type: Input
        }] }); })();

class HomepageModule {
}
HomepageModule.ɵfac = function HomepageModule_Factory(t) { return new (t || HomepageModule)(); };
HomepageModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: HomepageModule });
HomepageModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[BrSdkModule, CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HomepageModule, [{
        type: NgModule,
        args: [{
                declarations: [HomepageComponent],
                imports: [BrSdkModule, CommonModule],
                exports: [HomepageComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(HomepageModule, { declarations: [HomepageComponent], imports: [BrSdkModule, CommonModule], exports: [HomepageComponent] }); })();

class KnowledgeHubLayoutComponent {
    constructor(animationService, viewModeService) {
        this.animationService = animationService;
        this.viewModeService = viewModeService;
        this.isEditMode = false;
        this.unsubscribe$ = new Subject();
        this.animationService.showAnimation$
            .pipe(take(1), takeUntil(this.unsubscribe$))
            .subscribe(status => {
            this.animationService.setShowAnimation(status);
        });
        this.isEditMode = this.viewModeService.isEditMode();
    }
    /**
     * On Init
     */
    ngOnInit() { }
    /**
     * unsubscribes from animation service when service is destroyed
     */
    ngOnDestroy() {
        this.unsubscribe$.complete();
    }
}
KnowledgeHubLayoutComponent.ɵfac = function KnowledgeHubLayoutComponent_Factory(t) { return new (t || KnowledgeHubLayoutComponent)(i0.ɵɵdirectiveInject(i1.AnimationService), i0.ɵɵdirectiveInject(i1.ViewModeService)); };
KnowledgeHubLayoutComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: KnowledgeHubLayoutComponent, selectors: [["ft-alts-knowledge-hub-layout"]], inputs: { page: "page" }, decls: 8, vars: 0, consts: [["id", "skip-link-target", 1, "main-content", "remove-overflow-x"], [1, "knowledge-hub"], [1, "grid", "alts-scroll-line"], [1, "grid", "alts-banner-v3", "alts-banner-knowledge-hub"], [1, "alts-banner-v3__background"], ["brComponent", "lead-content"], ["brComponent", "title-content"], ["brComponent", "main-content"]], template: function KnowledgeHubLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "main", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "aside", 2);
        i0.ɵɵelementStart(3, "section", 3);
        i0.ɵɵelement(4, "div", 4);
        i0.ɵɵelementContainer(5, 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainer(6, 6);
        i0.ɵɵelementContainer(7, 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } }, directives: [i2.BrComponentDirective], styles: ["[_nghost-%COMP%]   .alts-banner-v3[_ngcontent-%COMP%]{position:relative;background:var(--ft-gradient-blue-to-teal-4);overflow:hidden}@media (max-width: 768px){[_nghost-%COMP%]   .alts-banner-v3.grid[_ngcontent-%COMP%]{margin:0}}[_nghost-%COMP%]   .alts-banner-v3.grid[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{position:relative;overflow:hidden}[_nghost-%COMP%]   .alts-banner-v3__background[_ngcontent-%COMP%]{display:flex;align-items:flex-end;background:var(--ft-gradient-knowledge_hub);top:0;bottom:0;height:100%;opacity:.8;position:absolute;right:0;width:100%}@media (max-width: 768px){[_nghost-%COMP%]   .alts-banner-v3__background[_ngcontent-%COMP%]{background:var(--ft-gradient-knowledge_hub)}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(KnowledgeHubLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-knowledge-hub-layout',
                templateUrl: './knowledge-hub-layout.component.html',
                styleUrls: ['./knowledge-hub-layout.component.scss'],
            }]
    }], function () { return [{ type: i1.AnimationService }, { type: i1.ViewModeService }]; }, { page: [{
            type: Input
        }] }); })();

class KnowledgeHubLayoutModule {
}
KnowledgeHubLayoutModule.ɵfac = function KnowledgeHubLayoutModule_Factory(t) { return new (t || KnowledgeHubLayoutModule)(); };
KnowledgeHubLayoutModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: KnowledgeHubLayoutModule });
KnowledgeHubLayoutModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[BrSdkModule, CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(KnowledgeHubLayoutModule, [{
        type: NgModule,
        args: [{
                declarations: [KnowledgeHubLayoutComponent],
                imports: [BrSdkModule, CommonModule],
                exports: [KnowledgeHubLayoutComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(KnowledgeHubLayoutModule, { declarations: [KnowledgeHubLayoutComponent], imports: [BrSdkModule, CommonModule], exports: [KnowledgeHubLayoutComponent] }); })();

class SpecialistLayoutComponent {
    constructor(animationService, viewModeService) {
        this.animationService = animationService;
        this.viewModeService = viewModeService;
        this.isEditMode = false;
        this.unsubscribe$ = new Subject();
        this.animationService.showAnimation$
            .pipe(take(1), takeUntil(this.unsubscribe$))
            .subscribe(status => {
            this.animationService.setShowAnimation(status);
        });
        this.isEditMode = this.viewModeService.isEditMode();
    }
    /**
     * On Init
     */
    ngOnInit() { }
    /**
     * unsubscribes from animation service when service is destroyed
     */
    ngOnDestroy() {
        this.unsubscribe$.complete();
    }
}
SpecialistLayoutComponent.ɵfac = function SpecialistLayoutComponent_Factory(t) { return new (t || SpecialistLayoutComponent)(i0.ɵɵdirectiveInject(i1.AnimationService), i0.ɵɵdirectiveInject(i1.ViewModeService)); };
SpecialistLayoutComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SpecialistLayoutComponent, selectors: [["ft-alts-specialist-layout"]], inputs: { page: "page" }, decls: 21, vars: 0, consts: [["id", "skip-link-target", 1, "main-content"], [1, "specialist"], [1, "grid", "alts-scroll-line"], [1, "grid", "alts-banner-specialist"], [1, "alts-banner-specialist__background"], ["xmlns", "http://www.w3.org/2000/svg", "width", "1189", "height", "426", "viewBox", "0 0 1189 426", "fill", "none", "data-di-res-id", "56803543-c343222c", "data-di-rand", "1695223077570"], ["opacity", "0.79", "filter", "url(#filter0_f_5854_111754)"], ["cx", "594.473", "cy", "648.168", "rx", "372.473", "ry", "426.277", "fill", "url(#paint0_linear_5854_111754)"], ["id", "filter0_f_5854_111754", "x", "0.125", "y", "0.015625", "width", "1188.7", "height", "1296.3", "filterUnits", "userSpaceOnUse", "color-interpolation-filters", "sRGB"], ["flood-opacity", "0", "result", "BackgroundImageFix"], ["mode", "normal", "in", "SourceGraphic", "in2", "BackgroundImageFix", "result", "shape"], ["stdDeviation", "110.938", "result", "effect1_foregroundBlur_5854_111754"], ["id", "paint0_linear_5854_111754", "x1", "561.552", "y1", "595.422", "x2", "330.451", "y2", "249.11", "gradientUnits", "userSpaceOnUse"], ["stop-color", "#A124CC"], ["offset", "1", "stop-color", "#A124CC"], [1, "alts-banner-specialist__content"], ["brComponent", "lead-content"], ["brComponent", "title-content"], ["brComponent", "main-content"]], template: function SpecialistLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "main", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "aside", 2);
        i0.ɵɵelementStart(3, "section", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "div");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(6, "svg", 5);
        i0.ɵɵelementStart(7, "g", 6);
        i0.ɵɵelement(8, "ellipse", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "defs");
        i0.ɵɵelementStart(10, "filter", 8);
        i0.ɵɵelement(11, "feFlood", 9);
        i0.ɵɵelement(12, "feBlend", 10);
        i0.ɵɵelement(13, "feGaussianBlur", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "linearGradient", 12);
        i0.ɵɵelement(15, "stop", 13);
        i0.ɵɵelement(16, "stop", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(17, "div", 15);
        i0.ɵɵelementContainer(18, 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainer(19, 17);
        i0.ɵɵelementContainer(20, 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } }, directives: [i2.BrComponentDirective], styles: ["[_nghost-%COMP%]   .alts-banner-specialist[_ngcontent-%COMP%]{margin-bottom:var(--space-mg);position:relative;background:var(--ft-gradient-blue-to-teal-4);overflow:hidden}[_nghost-%COMP%]   .alts-banner-specialist__background[_ngcontent-%COMP%]{width:100%;height:100%;position:absolute;top:0;left:0}[_nghost-%COMP%]   .alts-banner-specialist__background[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{position:absolute;width:100%;bottom:0}[_nghost-%COMP%]   .alts-banner-specialist__content[_ngcontent-%COMP%]{position:relative}@media (min-width: 0) and (max-width: 767.98px){[_nghost-%COMP%]     .specialist:has(ft-alts-staggered-cards) section.alts-banner-specialist~.br-container-box:has(.alts-staggered-cards-v4) section.alts-staggered-cards-v4{margin-top:-584px}}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpecialistLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-specialist-layout',
                templateUrl: './specialist-layout.component.html',
                styleUrls: ['./specialist-layout.component.scss'],
            }]
    }], function () { return [{ type: i1.AnimationService }, { type: i1.ViewModeService }]; }, { page: [{
            type: Input
        }] }); })();

class SpecialistLayoutModule {
}
SpecialistLayoutModule.ɵfac = function SpecialistLayoutModule_Factory(t) { return new (t || SpecialistLayoutModule)(); };
SpecialistLayoutModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SpecialistLayoutModule });
SpecialistLayoutModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[BrSdkModule, CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpecialistLayoutModule, [{
        type: NgModule,
        args: [{
                declarations: [SpecialistLayoutComponent],
                imports: [BrSdkModule, CommonModule],
                exports: [SpecialistLayoutComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SpecialistLayoutModule, { declarations: [SpecialistLayoutComponent], imports: [BrSdkModule, CommonModule], exports: [SpecialistLayoutComponent] }); })();

class LightboxModalComponent {
    constructor(el, renderer, lightboxService) {
        this.el = el;
        this.renderer = renderer;
        this.lightboxService = lightboxService;
        this.open = false;
    }
    ngOnInit() {
        this.lightboxService.changeCD(null);
        this.lightboxService.currentCD.subscribe((message) => {
            if (message) {
                this.lightboxContent = message;
                this.openLightbox();
            }
        });
    }
    openLightbox() {
        this.open = true;
        this.iframeDiv = this.el.nativeElement.querySelector('#alts-lightbox-modal__player');
        this.iframe = this.renderer.createElement('iframe');
        this.renderer.setAttribute(this.iframe, 'src', this.lightboxContent);
        this.renderer.addClass(this.iframe, 'lightbox-content');
        this.renderer.appendChild(this.iframeDiv, this.iframe);
    }
    closeLightbox() {
        this.open = false;
        this.renderer.removeChild(this.iframeDiv, this.iframe);
    }
}
LightboxModalComponent.ɵfac = function LightboxModalComponent_Factory(t) { return new (t || LightboxModalComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.LightboxModalService)); };
LightboxModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LightboxModalComponent, selectors: [["ft-alts-lightbox-modal"]], inputs: { lightboxContent: "lightboxContent" }, decls: 7, vars: 6, consts: [[1, "alts-lightbox-modal", "flex-center"], [1, "alts-lightbox-modal__overlay"], [1, "alts-lightbox-modal__content"], ["tabindex", "0", "aria-label", "Close popup", 1, "alts-lightbox-modal__content-close", "flex-center", 3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "width", "14", "height", "14", "viewBox", "0 0 14 14", "fill", "none"], ["d", "M13 1L1 13M1 1L13 13", "stroke", "white", "stroke-width", "2", "stroke-linecap", "round", "stroke-linejoin", "round"], ["id", "alts-lightbox-modal__player", 1, "alts-lightbox-modal__player"]], template: function LightboxModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "button", 3);
        i0.ɵɵlistener("click", function LightboxModalComponent_Template_button_click_3_listener() { return ctx.closeLightbox(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(4, "svg", 4);
        i0.ɵɵelement(5, "path", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelement(6, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassProp("alts-lightbox-modal--open", ctx.open);
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("alts-lightbox-modal__overlay--on", ctx.open);
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("alts-lightbox-modal__content--on", ctx.open);
    } }, styles: [".alts-lightbox-modal[_ngcontent-%COMP%]{display:none;position:fixed;top:0;left:0;height:100vh;width:100vw;pointer-events:none;transition:visibility 0s ease-in,opacity 0s ease-in;transition-delay:.6s;z-index:30}.alts-lightbox-modal--open[_ngcontent-%COMP%]{display:flex;opacity:1;pointer-events:all;transition-delay:0s;visibility:visible}.alts-lightbox-modal__overlay[_ngcontent-%COMP%]{position:absolute;height:100%;width:100%;background-color:var(--ft-black);opacity:0;transition:opacity .3s ease-in;transition-delay:.3s}.alts-lightbox-modal__overlay--on[_ngcontent-%COMP%]{opacity:.95;transition-delay:0s}.alts-lightbox-modal__content[_ngcontent-%COMP%]{padding:24px;margin:0 15px;max-height:90vh;max-width:1000px;overflow:hidden;position:relative;transform:translateY(15vh);transition:transform .3s ease-in,opacity .3s ease-in;width:100%}.alts-lightbox-modal__content--on[_ngcontent-%COMP%]{transform:translateY(0)}@media (max-width: 768px){.alts-lightbox-modal__content__player[_ngcontent-%COMP%]{margin:0 -24px}}.alts-lightbox-modal__content[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{aspect-ratio:16/9;height:100%;width:100%}.alts-lightbox-modal__content-close[_ngcontent-%COMP%]{position:absolute;right:0;top:0;width:1.5em;background-color:transparent;border:none;cursor:pointer;font-size:1rem;transition:transform .3s ease-in;z-index:30;outline:none}.alts-lightbox-modal__content-close[_ngcontent-%COMP%]:focus   svg[_ngcontent-%COMP%]{outline:1px solid var(--ft-sky-blue)}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LightboxModalComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-lightbox-modal',
                templateUrl: './lightbox-modal.component.html',
                styleUrls: ['./lightbox-modal.component.scss'],
            }]
    }], function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1.LightboxModalService }]; }, { lightboxContent: [{
            type: Input
        }] }); })();

function ProductLayoutComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelement(1, "span");
    i0.ɵɵelementEnd();
} }
function ProductLayoutComponent_ng_container_24_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 26);
} if (rf & 2) {
    const tabIndex_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("brComponent", "performance-tab-" + tabIndex_r2);
} }
function ProductLayoutComponent_ng_container_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductLayoutComponent_ng_container_24_ng_container_1_Template, 1, 1, "ng-container", 25);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r3 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.activeTabNumber === i_r3 || ctx_r1.isEditMode);
} }
const _c0 = function (a0, a1) { return { "product-layout__container--desktop": a0, "product-layout__container--mobile": a1 }; };
class ProductLayoutComponent {
    constructor(productConfigService, animationService, viewModeService, responsiveService, perfTabsService, productSnapshotService, cdr) {
        this.productConfigService = productConfigService;
        this.animationService = animationService;
        this.viewModeService = viewModeService;
        this.responsiveService = responsiveService;
        this.perfTabsService = perfTabsService;
        this.productSnapshotService = productSnapshotService;
        this.cdr = cdr;
        this.isEditMode = false;
        this.activeTabNumber = 0;
        this.subscriptions = [];
        this.unsubscribe$ = new Subject();
        this.animationService.showAnimation$.pipe(take(1), takeUntil(this.unsubscribe$)).subscribe((status) => {
            this.animationService.setShowAnimation(status);
        });
        this.isEditMode = this.viewModeService.isEditMode();
    }
    ngOnInit() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        // Initialize isHandheld hook.
        this.isHandheld$ = this.responsiveService.isHandheld$();
        this.subscriptions.push(
        // Subscribe to tabs select event.
        this.perfTabsService.getSelectedTabNumber$().subscribe((currentTabNumber) => (this.activeTabNumber = currentTabNumber)));
        // debugger;
        // Read fundId and shareClass from parameters
        const pageModelConfig = (_c = (_b = (_a = this.page) === null || _a === void 0 ? void 0 : _a.getComponent()) === null || _b === void 0 ? void 0 : _b.getModels()) === null || _c === void 0 ? void 0 : _c.config;
        const productConfig = this.productConfigService.getProductConfig(this.page);
        // Define the fundId and shareClass using nullish coalescing
        const fundId = (_d = pageModelConfig === null || pageModelConfig === void 0 ? void 0 : pageModelConfig.fundId) !== null && _d !== void 0 ? _d : productConfig === null || productConfig === void 0 ? void 0 : productConfig.fundId;
        const shareClassCode = (_e = pageModelConfig === null || pageModelConfig === void 0 ? void 0 : pageModelConfig.shareClassCode) !== null && _e !== void 0 ? _e : (_g = (_f = productConfig === null || productConfig === void 0 ? void 0 : productConfig.shareClasses) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.value;
        const countryCode = productConfig === null || productConfig === void 0 ? void 0 : productConfig.countryCode;
        const languageCode = productConfig === null || productConfig === void 0 ? void 0 : productConfig.languageCode;
        if (fundId) {
            const tabNames = (_h = PERF_CONFIG.getPerfTabConfig(fundId, shareClassCode)) === null || _h === void 0 ? void 0 : _h.tabs;
            this.tabIndexes = [];
            tabNames === null || tabNames === void 0 ? void 0 : tabNames.forEach((tabName) => {
                this.tabIndexes.push(PERF_CONFIG.TAB_NAME_INDEX_MAPPING[tabName]);
            });
            // Call GraphQL services for the page
            this.productSnapshotService.populateProductSnapshot(fundId, shareClassCode, countryCode, languageCode);
            this.cdr.detectChanges();
        }
    }
    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        this.unsubscribe$.complete();
    }
}
ProductLayoutComponent.ɵfac = function ProductLayoutComponent_Factory(t) { return new (t || ProductLayoutComponent)(i0.ɵɵdirectiveInject(i1.ProductsConfigService), i0.ɵɵdirectiveInject(i1.AnimationService), i0.ɵɵdirectiveInject(i1.ViewModeService), i0.ɵɵdirectiveInject(i1.ResponsiveService), i0.ɵɵdirectiveInject(i2$1.PerfTabsService), i0.ɵɵdirectiveInject(i3.ProductSnapshotService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
ProductLayoutComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProductLayoutComponent, selectors: [["ft-alts-product-layout"]], inputs: { page: "page" }, decls: 29, vars: 12, consts: [["_ngcontent-npk-c43", "", 1, "grid", "alts-scroll-line"], [1, "grid", "alts-products-hero"], [1, "alts-products-hero__background"], ["xmlns", "http://www.w3.org/2000/svg", "width", "1536", "height", "531", "viewBox", "0 0 1536 531", "fill", "none"], ["d", "M409 244.815C148.5 497.315 0 531 0 531H1536C1359.5 347.5 1196.9 146.477 1052.5 68C776.5 -81.9998 625.246 35.2099 409 244.815Z", "fill", "url(#paint0_linear_2407_74571)"], ["id", "paint0_linear_2407_74571", "x1", "534.5", "y1", "121.5", "x2", "907.5", "y2", "449", "gradientUnits", "userSpaceOnUse"], ["stop-color", "#4B00B6"], ["offset", "1", "stop-color", "#4B00B6", "stop-opacity", "0"], ["brComponent", "lead-content"], ["brComponent", "main-content"], ["id", "skip-link-target", 1, "main-content"], ["class", "product-layout__bubble", 4, "ngIf"], [1, "product-layout"], [1, "grid"], [3, "ngClass"], [1, "padding-bottom--lg"], ["brComponent", "performance-header"], [1, "spacing--md"], ["brComponent", "performance-tabs"], [4, "ngFor", "ngForOf"], ["brComponent", "performance-tab-footer"], ["brComponent", "portfolio"], ["brComponent", "portfolio-content"], ["brComponent", "lower-content"], [1, "product-layout__bubble"], [3, "brComponent", 4, "ngIf"], [3, "brComponent"]], template: function ProductLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "aside", 0);
        i0.ɵɵelementStart(1, "section", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(3, "svg", 3);
        i0.ɵɵelement(4, "path", 4);
        i0.ɵɵelementStart(5, "defs");
        i0.ɵɵelementStart(6, "linearGradient", 5);
        i0.ɵɵelement(7, "stop", 6);
        i0.ɵɵelement(8, "stop", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementContainer(9, 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainer(10, 9);
        i0.ɵɵelementStart(11, "main", 10);
        i0.ɵɵtemplate(12, ProductLayoutComponent_div_12_Template, 2, 0, "div", 11);
        i0.ɵɵpipe(13, "async");
        i0.ɵɵelementStart(14, "section", 12);
        i0.ɵɵelementStart(15, "div", 13);
        i0.ɵɵelementStart(16, "div", 14);
        i0.ɵɵpipe(17, "async");
        i0.ɵɵpipe(18, "async");
        i0.ɵɵelementStart(19, "div", 15);
        i0.ɵɵelementContainer(20, 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 17);
        i0.ɵɵelementContainer(22, 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 17);
        i0.ɵɵtemplate(24, ProductLayoutComponent_ng_container_24_Template, 2, 1, "ng-container", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainer(25, 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainer(26, 21);
        i0.ɵɵelementContainer(27, 22);
        i0.ɵɵelementContainer(28, 23);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(12);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(13, 3, ctx.isHandheld$));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(9, _c0, !i0.ɵɵpipeBind1(17, 5, ctx.isHandheld$), i0.ɵɵpipeBind1(18, 7, ctx.isHandheld$)));
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngForOf", ctx.tabIndexes);
    } }, directives: [i2.BrComponentDirective, i5.NgIf, i5.NgClass, i5.NgForOf], pipes: [i5.AsyncPipe], styles: [".alts-products-hero[_ngcontent-%COMP%]{position:relative;background:var(--ft-gradient-blue-to-teal)}.alts-products-hero__background[_ngcontent-%COMP%]{overflow:hidden;width:100%;height:100%;position:absolute;top:0;left:0;pointer-events:none;background:var(--ft-gradient-transparent-to-purple)}.alts-products-hero__background[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{position:absolute;left:50%;transform:translate(-50%);bottom:0}.product-layout[_ngcontent-%COMP%]{position:relative;padding-top:var(--space-mg);padding-bottom:var(--space-mg);background-color:var(--ft-charts-alts-dark-blue)}.product-layout[_ngcontent-%COMP%]   .grid[_ngcontent-%COMP%]{position:relative}.product-layout__container--desktop[_ngcontent-%COMP%]{width:83%!important;margin:0 auto!important}.product-layout__container--mobile[_ngcontent-%COMP%]{padding-left:var(--space-s)!important;padding-right:var(--space-s)!important}.product-layout__bubble[_ngcontent-%COMP%]{display:flex;position:absolute;margin-top:var(--space-md);margin-left:calc(var(--space-s) - 10px);z-index:4}.product-layout__bubble[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{width:20px;height:20px;border-radius:50%;background-color:var(--ft-sky-blue)}.alts-banner[_ngcontent-%COMP%]{position:relative;background:var(--ft-gradient-blue-to-teal)}.alts-banner.active[_ngcontent-%COMP%]:not(.active-state)   .tag[_ngcontent-%COMP%]{animation:leftTransitionAnimation 1s ease-out forwards}.alts-banner.active[_ngcontent-%COMP%]:not(.active-state)   .alts-banner__content-heading[_ngcontent-%COMP%]{animation:leftTransitionAnimation 1s ease-out forwards}.alts-banner.active[_ngcontent-%COMP%]:not(.active-state)   .alts-banner__dropdown[_ngcontent-%COMP%]{animation:bottomTransitionAnimation 1s ease-out forwards,fadeInAnimation 1s ease-out forwards}.alts-banner.active[_ngcontent-%COMP%]:not(.active-state)   .alts-banner__content-right[_ngcontent-%COMP%]{animation:bottomTransitionAnimation 1.5s ease-out forwards,fadeInAnimation 1.5s ease-out forwards}.alts-banner.active[_ngcontent-%COMP%]:not(.active-state)   .alts-banner__stats[_ngcontent-%COMP%]{animation:bottomTransitionAnimation 1s ease-out forwards 1s,fadeInAnimation 1s ease-out forwards 1s}.alts-banner.active[_ngcontent-%COMP%]:not(.active-state)   .alts-banner__fund[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{animation:fadeInAnimation .5s ease-out forwards 3.5s}@media (max-width: 768px){.alts-banner.grid[_ngcontent-%COMP%]{margin:0}}.alts-banner.grid[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{position:relative;overflow:hidden}.alts-banner__background[_ngcontent-%COMP%]{overflow:hidden;width:100%;height:100%;position:absolute;top:0;left:0;pointer-events:none;background:var(--ft-gradient-transparent-to-purple)}.alts-banner__background[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{position:absolute;left:50%;transform:translate(-50%);bottom:0}.alts-banner__content[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:column}@media (min-width: 768px){.alts-banner__content[_ngcontent-%COMP%]{flex-direction:row}}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]{pointer-events:none;position:absolute;top:0;left:0;width:100%;height:100%}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .bottom-lines-wrapper[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .bottom-lines-wrapper[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%;top:0;left:0}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .bottom-lines-wrapper[_ngcontent-%COMP%]   .left-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .bottom-lines-wrapper[_ngcontent-%COMP%]   .left-line[_ngcontent-%COMP%]{position:absolute;bottom:100px;left:27%;height:160px;width:1px;background-color:var(--ft-white);opacity:0}@media (min-width: 1200px){.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .bottom-lines-wrapper[_ngcontent-%COMP%]   .left-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .bottom-lines-wrapper[_ngcontent-%COMP%]   .left-line[_ngcontent-%COMP%]{opacity:.4}}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%;top:0;left:0}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .left-edge-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .left-edge-line[_ngcontent-%COMP%]{position:absolute;left:15px;height:100%;width:1px;background-color:var(--ft-white);opacity:.4}@media (min-width: 768px){.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .left-edge-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .left-edge-line[_ngcontent-%COMP%]{left:20px}}@media (min-width: 1024px){.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .left-edge-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .left-edge-line[_ngcontent-%COMP%]{left:28px}}@media (min-width: 1600px){.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .left-edge-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .left-edge-line[_ngcontent-%COMP%]{left:32px}}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .left-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .left-line[_ngcontent-%COMP%]{position:absolute;top:0;left:27%;height:175px;width:1px;background-color:var(--ft-white);opacity:0}@media (min-width: 1200px){.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .left-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .left-line[_ngcontent-%COMP%]{opacity:.4}}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .middle-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .middle-line[_ngcontent-%COMP%]{position:absolute;left:calc(50% - 1px);height:64px;width:1px;background-color:var(--ft-white);opacity:.4}@media (min-width: 1200px){.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .middle-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .middle-line[_ngcontent-%COMP%]{height:100%}}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .right-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .right-line[_ngcontent-%COMP%]{position:absolute;right:22%;height:175px;width:1px;background-color:var(--ft-white);opacity:0}@media (min-width: 1200px){.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .right-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .right-line[_ngcontent-%COMP%]{opacity:.4}}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .right-edge-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .right-edge-line[_ngcontent-%COMP%]{position:absolute;right:15px;height:100%;width:1px;background-color:var(--ft-white);opacity:.4}@media (min-width: 768px){.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .right-edge-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .right-edge-line[_ngcontent-%COMP%]{right:20px}}@media (min-width: 1024px){.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .right-edge-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .right-edge-line[_ngcontent-%COMP%]{right:28px}}@media (min-width: 1600px){.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .right-edge-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .top-lines-wrapper[_ngcontent-%COMP%]   .right-edge-line[_ngcontent-%COMP%]{right:31px}}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]{position:relative;width:100%;height:100%;top:0;left:0}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]{padding:0 8px;position:absolute;left:0;width:100%;height:100%}@media (min-width: 1024px){.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]{padding:0 var(--space-xs)}}@media (min-width: 1200px){.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]{padding:0 var(--space-xs)}}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]   .inner-wrapper[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]   .inner-wrapper[_ngcontent-%COMP%]{width:100%;height:100%;position:relative;left:0}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]   .inner-wrapper[_ngcontent-%COMP%]   .top-horizontal-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]   .inner-wrapper[_ngcontent-%COMP%]   .top-horizontal-line[_ngcontent-%COMP%]{position:absolute;width:100%;top:64px;height:1px;background-color:var(--ft-white);opacity:.4;z-index:2}@media (min-width: 1200px){.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]   .inner-wrapper[_ngcontent-%COMP%]   .top-horizontal-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]   .inner-wrapper[_ngcontent-%COMP%]   .top-horizontal-line[_ngcontent-%COMP%]{top:160px}}.alts-banner[_ngcontent-%COMP%]   .animated-lines[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]   .inner-wrapper[_ngcontent-%COMP%]   .bottom-horizontal-line[_ngcontent-%COMP%], .alts-banner[_ngcontent-%COMP%]   .animated-lines-horizontal[_ngcontent-%COMP%]   .horizontal-lines[_ngcontent-%COMP%]   .wrapper[_ngcontent-%COMP%]   .inner-wrapper[_ngcontent-%COMP%]   .bottom-horizontal-line[_ngcontent-%COMP%]{position:absolute;width:50%;bottom:260px;height:1px;background-color:var(--ft-white);opacity:.4}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-product-layout',
                templateUrl: './product-layout.component.html',
                styleUrls: ['./product-layout.component.scss'],
            }]
    }], function () { return [{ type: i1.ProductsConfigService }, { type: i1.AnimationService }, { type: i1.ViewModeService }, { type: i1.ResponsiveService }, { type: i2$1.PerfTabsService }, { type: i3.ProductSnapshotService }, { type: i0.ChangeDetectorRef }]; }, { page: [{
            type: Input
        }] }); })();

class CategoriesLayoutComponent {
    constructor(animationService, viewModeService) {
        this.animationService = animationService;
        this.viewModeService = viewModeService;
        this.isEditMode = false;
        this.unsubscribe$ = new Subject();
        this.animationService.showAnimation$
            .pipe(take(1), takeUntil(this.unsubscribe$))
            .subscribe(status => {
            this.animationService.setShowAnimation(status);
        });
        this.isEditMode = this.viewModeService.isEditMode();
    }
    /**
     * On Init
     */
    ngOnInit() { }
    /**
     * unsubscribes from animation service when service is destroyed
     */
    ngOnDestroy() {
        this.unsubscribe$.complete();
    }
}
CategoriesLayoutComponent.ɵfac = function CategoriesLayoutComponent_Factory(t) { return new (t || CategoriesLayoutComponent)(i0.ɵɵdirectiveInject(i1.AnimationService), i0.ɵɵdirectiveInject(i1.ViewModeService)); };
CategoriesLayoutComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CategoriesLayoutComponent, selectors: [["ft-alts-categories-layout"]], inputs: { page: "page" }, decls: 15, vars: 0, consts: [["id", "skip-link-target", 1, "main-content"], [1, "specialist"], [1, "grid", "alts-scroll-line"], [1, "grid", "alts-banner-categories"], [1, "alts-banner-categories__background"], ["xmlns", "http://www.w3.org/2000/svg", "width", "1522", "height", "174", "viewBox", "0 0 1522 174", "fill", "none"], ["d", "M409 244.49C148.5 496.99 0 530.675 0 530.675H1536C1359.5 347.176 1196.9 146.152 1052.5 67.6758C776.5 -82.3241 625.246 34.8857 409 244.49Z", "fill", "url(#paint0_linear_2407_74638)"], ["id", "paint0_linear_2407_74638", "x1", "534.5", "y1", "121.176", "x2", "907.5", "y2", "448.676", "gradientUnits", "userSpaceOnUse"], ["stop-color", "#A124CC", "stop-opacity", "0.5"], ["offset", "1", "stop-color", "#A124CC", "stop-opacity", "0"], [1, "alts-banner-categories__content"], ["brComponent", "lead-content"], ["brComponent", "title-content"], ["brComponent", "main-content"]], template: function CategoriesLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "main", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelement(2, "aside", 2);
        i0.ɵɵelementStart(3, "section", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(5, "svg", 5);
        i0.ɵɵelement(6, "path", 6);
        i0.ɵɵelementStart(7, "defs");
        i0.ɵɵelementStart(8, "linearGradient", 7);
        i0.ɵɵelement(9, "stop", 8);
        i0.ɵɵelement(10, "stop", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(11, "div", 10);
        i0.ɵɵelementContainer(12, 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementContainer(13, 12);
        i0.ɵɵelementContainer(14, 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } }, directives: [i2.BrComponentDirective], styles: ["[_nghost-%COMP%]   .alts-banner-categories[_ngcontent-%COMP%]{margin-bottom:var(--space-mg);position:relative;background:var(--ft-gradient-blue-to-teal-2);overflow:hidden}[_nghost-%COMP%]   .alts-banner-categories__background[_ngcontent-%COMP%]{width:100%;height:100%;position:absolute;top:0;left:0;background:var(--ft-gradient-transparent-to-purple)}[_nghost-%COMP%]   .alts-banner-categories__background[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{position:absolute;width:100%;bottom:0}[_nghost-%COMP%]   .alts-banner-categories__content[_ngcontent-%COMP%]{position:relative}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CategoriesLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-categories-layout',
                templateUrl: './categories-layout.component.html',
                styleUrls: ['./categories-layout.component.scss'],
            }]
    }], function () { return [{ type: i1.AnimationService }, { type: i1.ViewModeService }]; }, { page: [{
            type: Input
        }] }); })();

function LayoutComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 6);
} }
function LayoutComponent_ft_alts_product_layout_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-product-layout", 7);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("page", ctx_r1.page);
} }
function LayoutComponent_ft_alts_knowledge_hub_layout_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-knowledge-hub-layout", 7);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("page", ctx_r2.page);
} }
function LayoutComponent_ft_alts_categories_layout_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-categories-layout", 7);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("page", ctx_r3.page);
} }
function LayoutComponent_ft_alts_specialist_layout_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-specialist-layout", 7);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("page", ctx_r4.page);
} }
function LayoutComponent_ft_alts_homepage_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ft-alts-homepage", 7);
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("page", ctx_r5.page);
} }
function LayoutComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 8);
} }
class LayoutComponent {
    constructor(viewModeService) {
        this.viewModeService = viewModeService;
        /**
         * Lets use the layout to determine whether
         */
        this.PRODUCT_LAYOUT = 'alts-product-page-layout';
        this.showHeaderAndFooter = true;
        /**
         * Used to detect the BRXM edit mode
         */
        this.isEditMode = false;
        this.isEditMode = this.viewModeService.isEditMode();
    }
    /**
     * On Init
     */
    ngOnInit() {
        var _a, _b, _c;
        this.layoutName = (_c = (_b = (_a = this.page) === null || _a === void 0 ? void 0 : _a.getComponent()) === null || _b === void 0 ? void 0 : _b.getParameters()) === null || _c === void 0 ? void 0 : _c.layout;
    }
}
LayoutComponent.ɵfac = function LayoutComponent_Factory(t) { return new (t || LayoutComponent)(i0.ɵɵdirectiveInject(i1.ViewModeService)); };
LayoutComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LayoutComponent, selectors: [["ft-alts-layout"]], inputs: { showHeaderAndFooter: "showHeaderAndFooter", page: "page" }, decls: 10, vars: 7, consts: [["brComponent", "header-content", 4, "ngIf"], ["offLabel", "Off", "onLabel", "On", "variant", "animation"], [3, "ngSwitch"], [3, "page", 4, "ngSwitchCase"], [3, "page", 4, "ngSwitchDefault"], ["brComponent", "footer-content", 4, "ngIf"], ["brComponent", "header-content"], [3, "page"], ["brComponent", "footer-content"]], template: function LayoutComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LayoutComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        i0.ɵɵelement(1, "ft-alts-switch", 1);
        i0.ɵɵelementContainerStart(2, 2);
        i0.ɵɵtemplate(3, LayoutComponent_ft_alts_product_layout_3_Template, 1, 1, "ft-alts-product-layout", 3);
        i0.ɵɵtemplate(4, LayoutComponent_ft_alts_knowledge_hub_layout_4_Template, 1, 1, "ft-alts-knowledge-hub-layout", 3);
        i0.ɵɵtemplate(5, LayoutComponent_ft_alts_categories_layout_5_Template, 1, 1, "ft-alts-categories-layout", 3);
        i0.ɵɵtemplate(6, LayoutComponent_ft_alts_specialist_layout_6_Template, 1, 1, "ft-alts-specialist-layout", 3);
        i0.ɵɵtemplate(7, LayoutComponent_ft_alts_homepage_7_Template, 1, 1, "ft-alts-homepage", 4);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelement(8, "ft-alts-lightbox-modal");
        i0.ɵɵtemplate(9, LayoutComponent_ng_container_9_Template, 1, 0, "ng-container", 5);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showHeaderAndFooter);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngSwitch", ctx.layoutName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "alts-product-page-layout");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "alts-knowledge-hub-layout");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "alts-categories-layout");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngSwitchCase", "alts-specialist-layout");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.showHeaderAndFooter);
    } }, directives: [i5.NgIf, i1.SwitchComponent, i5.NgSwitch, i5.NgSwitchCase, i5.NgSwitchDefault, LightboxModalComponent, i2.BrComponentDirective, ProductLayoutComponent, KnowledgeHubLayoutComponent, CategoriesLayoutComponent, SpecialistLayoutComponent, HomepageComponent], styles: [""] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LayoutComponent, [{
        type: Component,
        args: [{
                selector: 'ft-alts-layout',
                templateUrl: './layout.component.html',
                styleUrls: ['./layout.component.scss'],
            }]
    }], function () { return [{ type: i1.ViewModeService }]; }, { showHeaderAndFooter: [{
            type: Input
        }], page: [{
            type: Input
        }] }); })();

class ProductLayoutModule {
}
ProductLayoutModule.ɵfac = function ProductLayoutModule_Factory(t) { return new (t || ProductLayoutModule)(); };
ProductLayoutModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ProductLayoutModule });
ProductLayoutModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [PerfTabsService], imports: [[BrSdkModule, CommonModule, HttpClientModule, ProductHeroModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductLayoutModule, [{
        type: NgModule,
        args: [{
                declarations: [ProductLayoutComponent],
                imports: [BrSdkModule, CommonModule, HttpClientModule, ProductHeroModule],
                exports: [ProductLayoutComponent],
                providers: [PerfTabsService],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ProductLayoutModule, { declarations: [ProductLayoutComponent], imports: [BrSdkModule, CommonModule, HttpClientModule, ProductHeroModule], exports: [ProductLayoutComponent] }); })();

class CategoriesLayoutModule {
}
CategoriesLayoutModule.ɵfac = function CategoriesLayoutModule_Factory(t) { return new (t || CategoriesLayoutModule)(); };
CategoriesLayoutModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CategoriesLayoutModule });
CategoriesLayoutModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[BrSdkModule, CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CategoriesLayoutModule, [{
        type: NgModule,
        args: [{
                declarations: [CategoriesLayoutComponent],
                imports: [BrSdkModule, CommonModule],
                exports: [CategoriesLayoutComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CategoriesLayoutModule, { declarations: [CategoriesLayoutComponent], imports: [BrSdkModule, CommonModule], exports: [CategoriesLayoutComponent] }); })();

class LightboxModalModule {
}
LightboxModalModule.ɵfac = function LightboxModalModule_Factory(t) { return new (t || LightboxModalModule)(); };
LightboxModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LightboxModalModule });
LightboxModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LightboxModalModule, [{
        type: NgModule,
        args: [{
                declarations: [LightboxModalComponent],
                imports: [CommonModule],
                exports: [LightboxModalComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LightboxModalModule, { declarations: [LightboxModalComponent], imports: [CommonModule], exports: [LightboxModalComponent] }); })();

class LayoutModule {
}
LayoutModule.ɵfac = function LayoutModule_Factory(t) { return new (t || LayoutModule)(); };
LayoutModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LayoutModule });
LayoutModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [], imports: [[
            BrSdkModule,
            CommonModule,
            CategoriesLayoutModule,
            HomepageModule,
            KnowledgeHubLayoutModule,
            ProductLayoutModule,
            SpecialistLayoutModule,
            LightboxModalModule,
            SwitchModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LayoutModule, [{
        type: NgModule,
        args: [{
                providers: [],
                declarations: [LayoutComponent],
                imports: [
                    BrSdkModule,
                    CommonModule,
                    CategoriesLayoutModule,
                    HomepageModule,
                    KnowledgeHubLayoutModule,
                    ProductLayoutModule,
                    SpecialistLayoutModule,
                    LightboxModalModule,
                    SwitchModule,
                ],
                exports: [LayoutComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LayoutModule, { declarations: [LayoutComponent], imports: [BrSdkModule,
        CommonModule,
        CategoriesLayoutModule,
        HomepageModule,
        KnowledgeHubLayoutModule,
        ProductLayoutModule,
        SpecialistLayoutModule,
        LightboxModalModule,
        SwitchModule], exports: [LayoutComponent] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { HomepageComponent, HomepageModule, KnowledgeHubLayoutComponent, KnowledgeHubLayoutModule, LayoutComponent, LayoutModule, LightboxModalComponent, LightboxModalModule, ProductLayoutComponent, ProductLayoutModule, SpecialistLayoutComponent, SpecialistLayoutModule };
